export default __webpack_public_path__ + "static/media/create.749faf66.svg";